export const sendSmsWithOtpUrl = "api/smsauthentication/sms";
export const logInUrl = "api/smsauthentication/otp";
export const signDocumentUrl = "api/documentsign";